<div class="model-card" [class.model-card--list-view]="showShortDescription" (click)="onCardClick()">
  <!-- Card Content -->
  <div class="model-card__content">
    <!-- Row 1 list view: Label (title) left | Like View right. Grid: title only -->
    <div class="model-card__header-row">
      <div class="model-card__title-row">
        <h3 class="model-card__title">{{ card.title }}</h3>
        <!-- Bookmark Badge (same as dataset card) -->
        <div class="model-card__bookmark" *ngIf="isLoggedIn && isBookmarked">
          <svg class="model-card__bookmark-icon" width="16" height="16" viewBox="0 0 24 24" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M19 21L12 16L5 21V5C5 3.89543 5.89543 3 7 3H17C18.1046 3 19 3.89543 19 5V21Z" fill="#059669"
              stroke="#059669" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>

        <!-- Share feature: commented out for now. Uncomment to re-enable.
        <app-card-share-button
          *ngIf="card.id"
          [title]="card.title"
          [path]="'/model/' + card.id"
          kind="Model"
        ></app-card-share-button>
        -->
      </div>
      <!-- List view: activity to the right of label -->
      <div
        class="model-card__header-metrics"
        *ngIf="showShortDescription && showActivityMetrics && card.metrics"
        (click)="$event.stopPropagation()"
      >
        <div
          class="model-card__metric-item"
          [class.active]="isLiked"
          [class.clickable]="isLoggedIn && likeActionEnabled"
          [class.model-card__metric-item--readonly-like]="!likeActionEnabled"
          [attr.aria-disabled]="!likeActionEnabled ? 'true' : null"
          (click)="onLikeRowClick($event)"
          *ngIf="card.metrics.likes !== undefined"
        >
          <svg class="model-card__metric-icon" width="20" height="20" viewBox="0 0 24 24" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
              [attr.fill]="isLiked ? '#059669' : 'none'" stroke="#059669" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          <span class="model-card__metric-value">{{ card.metrics.likes }}</span>
        </div>
        <div class="model-card__metric-item" *ngIf="card.metrics.views !== undefined">
          <svg class="model-card__metric-icon" width="20" height="20" viewBox="0 0 24 24" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" stroke="currentColor"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          <span class="model-card__metric-value">{{ card.metrics.views | number }}</span>
        </div>
      </div>
    </div>

    <!-- Short description (one line, ellipsis) - list/grid when present -->
    <p class="model-card__short-description" *ngIf="card.shortDescription">{{ card.shortDescription }}</p>

    <!-- Tags -->
    <div class="model-card__tags">
      <span *ngFor="let tag of card.tags" class="model-card__tag">
        {{ tag }}
      </span>
    </div>

    <!-- Sector, Model Type, File Format, Code Language – one below the other -->
    <div class="model-card__info-row" *ngIf="card.industry || card.modelType || card.fileFormat || card.language">
      <div class="model-card__info-item" *ngIf="card.industry">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
          <path d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path
            d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <span>{{ card.industry }}</span>
      </div>
      <div class="model-card__info-item" *ngIf="card.modelType">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="2" y="2" width="20" height="20" rx="2" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
          <path d="M8 2V22M16 2V22M2 8H22M2 16H22" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
        <span>{{ card.modelType }}</span>
      </div>
      <div class="model-card__info-item" *ngIf="card.fileFormat">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M13 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V9L13 2Z"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M13 2V9H20" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
        <span>{{ card.fileFormat }}</span>
      </div>
      <div class="model-card__info-item" *ngIf="card.language">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 4H6C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V16"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M15 2L18 5L15 8" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
          <path d="M9 2L6 5L9 8" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
        <span>{{ card.language }}</span>
      </div>
    </div>
  </div>

  <!-- Meta row: Created At + Public (left) | Arrow right (list); Created At (left) | Public (right) (grid) -->
  <div class="model-card__meta">
    <div class="model-card__meta-left-group">
      <div class="model-card__meta-left">
        <div class="model-card__date" *ngIf="card.date">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M12 6V12L16 14" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
          <span>{{ card.date }}</span>
        </div>
      </div>
      <div class="model-card__badge" [ngClass]="getBadgeClass()"
        [class.model-card__badge--right]="!showShortDescription" *ngIf="card.badge">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            d="M12 2C15.31 2 18.23 3.69 20.35 6.26C20.43 6.37 20.5 6.49 20.57 6.61C20.64 6.73 20.71 6.85 20.78 6.97C20.85 7.09 20.91 7.21 20.97 7.33C21.03 7.45 21.08 7.57 21.13 7.69C21.18 7.81 21.23 7.93 21.27 8.05C21.31 8.17 21.35 8.29 21.38 8.41C21.41 8.53 21.44 8.65 21.46 8.77C21.48 8.89 21.5 9.01 21.51 9.13C21.52 9.25 21.52 9.37 21.52 9.49C21.52 9.61 21.52 9.73 21.51 9.85C21.5 9.97 21.48 10.09 21.46 10.21C21.44 10.33 21.41 10.45 21.38 10.57C21.35 10.69 21.31 10.81 21.27 10.93C21.23 11.05 21.18 11.17 21.13 11.29C21.08 11.41 21.03 11.53 20.97 11.65C20.91 11.77 20.85 11.89 20.78 12.01C20.71 12.13 20.64 12.25 20.57 12.37C20.5 12.49 20.43 12.61 20.35 12.72C18.23 15.29 15.31 17 12 17C8.69 17 5.77 15.29 3.65 12.72C3.57 12.61 3.5 12.49 3.43 12.37C3.36 12.25 3.29 12.13 3.22 12.01C3.15 11.89 3.09 11.77 3.03 11.65C2.97 11.53 2.92 11.41 2.87 11.29C2.82 11.17 2.77 11.05 2.73 10.93C2.69 10.81 2.65 10.69 2.62 10.57C2.59 10.45 2.56 10.33 2.54 10.21C2.52 10.09 2.5 9.97 2.49 9.85C2.48 9.73 2.48 9.61 2.48 9.49C2.48 9.37 2.48 9.25 2.49 9.13C2.5 9.01 2.52 8.89 2.54 8.77C2.56 8.65 2.59 8.53 2.62 8.41C2.65 8.29 2.69 8.17 2.73 8.05C2.77 7.93 2.82 7.81 2.87 7.69C2.92 7.57 2.97 7.45 3.03 7.33C3.09 7.21 3.15 7.09 3.22 6.97C3.29 6.85 3.36 6.73 3.43 6.61C3.5 6.49 3.57 6.37 3.65 6.26C5.77 3.69 8.69 2 12 2Z"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M12 6V12L16 14" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
        <span>{{ card.badge }}</span>
      </div>
    </div>
    <div class="model-card__actions" *ngIf="showShortDescription">
      <button class="model-card__arrow model-card__arrow--meta" aria-label="View details"
        (click)="onCardClick(); $event.stopPropagation()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
    </div>
  </div>

  <!-- Footer: Like View (left) | Arrow (right) - grid view only -->
  <div class="model-card__footer" *ngIf="!showShortDescription" (click)="$event.stopPropagation()">
    <div class="model-card__footer-metrics" *ngIf="showActivityMetrics && card.metrics">
      <div
        class="model-card__metric-item"
        [class.active]="isLiked"
        [class.clickable]="isLoggedIn && likeActionEnabled"
        [class.model-card__metric-item--readonly-like]="!likeActionEnabled"
        [attr.aria-disabled]="!likeActionEnabled ? 'true' : null"
        (click)="onLikeRowClick($event)"
        *ngIf="card.metrics.likes !== undefined"
      >
        <svg class="model-card__metric-icon" width="20" height="20" viewBox="0 0 24 24" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
            [attr.fill]="isLiked ? '#059669' : 'none'" stroke="#059669" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
        <span class="model-card__metric-value">{{ card.metrics.likes }}</span>
      </div>
      <div class="model-card__metric-item" *ngIf="card.metrics.views !== undefined">
        <svg class="model-card__metric-icon" width="20" height="20" viewBox="0 0 24 24" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" stroke="currentColor"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
        <span class="model-card__metric-value">{{ card.metrics.views | number }}</span>
      </div>
    </div>
    <div class="model-card__actions">
      <button class="model-card__arrow" aria-label="View details" (click)="onCardClick(); $event.stopPropagation()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
    </div>
  </div>
</div>